// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1S__p","title":"FrontImage_title__1Igac"};